import { useEffect, useRef, useState } from "react";
import { TagWithIcon } from "../Tags";
import { ChevronDownOutlined } from "components/OldDesign/Icons";
import Button from "../Button/Button";

const Drawer = ({ action, suggestions }) => {
  const bodyRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [maxHeight, setMaxHeight] = useState("0px");
  const suggestionsLength = suggestions.length;

  useEffect(() => {
    if (isOpen && bodyRef.current) {
      setMaxHeight(`${bodyRef.current.scrollHeight + 10}px`);
    } else {
      setMaxHeight("0px");
    }
  }, [isOpen, suggestionsLength]);
  if (!action.title) {
    return null;
  }
  return (
    <div onClick={() => setIsOpen((prev) => !prev)} className={`${action.bgColor} rounded-lg p-4 max-lg:text-[13px]`}>
      <div className={`${action.textColor} flex items-center gap-1`}>
        <h4 className={`font-semibold leading-tight`}>{action.title}</h4>
        <TagWithIcon className={`${action.textColor} bg-neutral-100 px-2 py-1`} text={suggestionsLength} />
        <Button
          className="ml-auto border-none bg-transparent p-0"
          icon={
            <ChevronDownOutlined className={`${action.textColor} ${isOpen && "rotate-180"} h-5 w-5 transition-all`} />
          }
        />
      </div>
      <div
        ref={bodyRef}
        className="flex flex-col gap-3 overflow-hidden transition-all duration-300"
        style={{ maxHeight, paddingTop: isOpen ? "10px" : "0px" }}
      >
        {suggestions.map((suggestion, index) => {
          return (
            <div key={index} className="flex gap-1">
              <div>{action.icon}</div>
              <p className="text-sm leading-tight text-neutral-1000 text-opacity-90">{suggestion.description}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Drawer;
